<template>
  <div>
    <yjheader title="自选合约"></yjheader>
    <tradeList :contentData="vmSelected" @longpress="handleLongPress"></tradeList>
    <div v-if="actionMenu.visible" class="lp-mask" @click="closeActionMenu">
      <div class="lp-menu" :style="{ left: actionMenu.left + 'px', top: actionMenu.top + 'px' }" @click.stop>
        <div class="lp-item lp-danger" @click="handleRemoveSelected">
          <i class="icon iconfont icon-jianhao"></i>
          删自选
        </div>
        <div class="lp-arrow" :style="{ left: actionMenu.arrowLeft + 'px' }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import yjheader from "@/components/common/yjheader";
import tradeList from "@/components/common/tradeList";
import art from "../../../static/js/proto/art/Art.js";
import front from "../../../static/js/proto/CtpFront.js";

// ---------------------------------------------------------------------------
export default {
  name: "selected",
  components: {
    yjheader,
    tradeList
  },

  ////////////////////////////////////////////////////////////////////////////
  data() {
    return {
      vmSelected: [],
      actionMenu: {
        visible: false,
        left: 0,
        top: 0,
        arrowLeft: 0,
        item: null
      }
    };
  },

  ////////////////////////////////////////////////////////////////////////////
  mounted() {},
  activated() {
    footerIndex = 0;
    front.autoMount(art.bind(this, this.subscribe));
  },
  deactivated() {
    this.unsubscribe();
    beferFooterIndex = 0;
  },

  ////////////////////////////////////////////////////////////////////////////
  computed: {
    targetSelected() {
      return this.$store.state.targetSelected;
    },
    name() {
      return this.$options.name;
    }
  },
  watch: {
    vmSelected(news, old) {
      this.$store.commit('upDataSelect', this.vmSelected);
    }
  },

  ////////////////////////////////////////////////////////////////////////////
  methods: {
    getPoint(e) {
      const touch = e && e.touches && e.touches[0];
      const changed = e && e.changedTouches && e.changedTouches[0];
      const point = touch || changed || e || {};
      return {
        clientX: point.clientX || 0,
        clientY: point.clientY || 0
      };
    },
    handleLongPress(payload) {
      const e = payload && payload.event ? payload.event : payload;
      const item = payload && payload.item ? payload.item : null;
      const p = this.getPoint(e);

      const menuWidth = 160;
      const menuHeight = 46;
      const margin = 10;

      let left = p.clientX - menuWidth / 2;
      left = Math.max(margin, Math.min(left, window.innerWidth - menuWidth - margin));

      let top = p.clientY - menuHeight - 14;
      if (top < margin) top = p.clientY + 14;
      top = Math.max(margin, Math.min(top, window.innerHeight - menuHeight - margin));

      let arrowLeft = p.clientX - left;
      arrowLeft = Math.max(16, Math.min(arrowLeft, menuWidth - 16));

      this.actionMenu.visible = true;
      this.actionMenu.left = left;
      this.actionMenu.top = top;
      this.actionMenu.arrowLeft = arrowLeft;
      this.actionMenu.item = item;
    },
    closeActionMenu() {
      this.actionMenu.visible = false;
      this.actionMenu.item = null;
    },
    handleRemoveSelected() {
      const item = this.actionMenu.item;
      const targetId = item && item.targetId ? item.targetId : "";
      this.closeActionMenu();
      if (!targetId) return;

      front.selectedTargetRemove(
        targetId,
        () => {
          this.$toast("删除自选成功");
          this.$store.commit("selectRemove", targetId);
          front.unsubTick(targetId, this.name);
          art.erase(this.vmSelected, targetId, "targetId");
        },
        (reject) => {
          if (reject.id == front.e_network) {
            this.$toast("删除自选失败，网络异常");
          } else if (reject.id == front.e_selected_removed) {
            this.$toast("删除自选重复");
          } else {
            this.$toast("删除自选失败");
          }
        }
      );
    },
    // 订阅自选列表
    subscribe(reject) {
      var subTick = targetId =>
        front.subTick(targetId, {
          suberId: this.name,
          publish: tick => this.onTick(tick)
        });

      var addTarget = targetId => {
        if (!art.find(this.vmSelected, targetId, "targetId")) {
          const target = front.targetSet[targetId];
          if (target) {
            this.vmSelected.push({
              volume: 0,
              latestPrice: 0,
              lastSettlementPrice: 0,
              targetId: targetId,
              targetName: target.targetName
            });
          }
        } // endif
      };

      // 接收推送信息
      var publish = target => {
        if (!target.targetId) {
          return;
        }
        if (target.stamp == art.meta.stamp_clean) {
          this.$store.commit("selectLoad");
          art.clear(this.vmSelected);
          return;
        }
        // 删除自选
        if (target.stamp == art.meta.stamp_remove) {
          if (!art.find(this.vmSelected, target.targetId, "targetId")) {
            this.$store.commit("selectRemove", target.targetId);
            return;
          }
          this.$store.commit("selectRemove", target.targetId);
          front.unsubTick(target.targetId, this.name);
          art.erase(this.vmSelected, target.targetId, "targetId");
          return;
        }
        // 添加自选
        this.$store.commit("selectInsert", target.targetId);
        addTarget(target.targetId);
        subTick(target.targetId);
      };

      // 初始化本地列表
      art.clear(this.vmSelected);
      if (this.targetSelected) {
        for (var targetId in this.targetSelected) {
          addTarget(targetId);
          subTick(targetId);
        }
      }

      // 订阅自选列表
      var sub = front.selectedTargetSub({
        suberId: this.name,
        publish,
        reject
      });
      this.$store.commit("selectLoad", sub);
      // console.log(this.vmSelected)
    },

    //////////////////////////////////////////////////////////////////////////
    // 取消订阅自选列表
    unsubscribe() {
      front.selectedTargetUnsub(this.name);
      if (this.targetSelected) {
        for (var targetId in this.targetSelected) {
          front.unsubTick(targetId, this.name);
        }
      }
    },

    //////////////////////////////////////////////////////////////////////////
    // 合约行情信息
    onTick(tick) {
      // 只更新行情列表：添加由subscribe负责。
      var vm = art.find(this.vmSelected, tick.targetId, "targetId");
      if (vm) {
        var data = this.vmSelected[vm.index];
        data.volume = tick.volume;
        data.latestPrice = tick.latestPrice;
        data.lastSettlementPrice = tick.lastSettlementPrice;
        return;
      }
      console.error("warn" + tick.targetId);
    }

    //////////////////////////////////////////////////////////////////////////
  },// VUE.METHODS
}; // VUE.
</script>

<style scoped>
.lp-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0);
}

.lp-menu {
  position: fixed;
  width: 160px;
  height: 46px;
  background: #2b2b2b;
  border: 1px solid #3f3f3f;
  border-radius: 8px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
}

.lp-item {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.32rem;
  color: #f5f9fc;
}

.lp-item i {
  margin-right: 8px;
  font-size: 18px;
  line-height: 1;
}

.lp-danger {
  color: #ff0000;
}

.lp-arrow {
  position: absolute;
  bottom: -10px;
  transform: translateX(-50%);
  width: 0;
  height: 0;
}

.lp-arrow::before {
  content: "";
  position: absolute;
  left: -9px;
  top: 0;
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-top: 10px solid #3f3f3f;
}

.lp-arrow::after {
  content: "";
  position: absolute;
  left: -8px;
  top: -1px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 9px solid #2b2b2b;
}
</style>



// WEBPACK FOOTER //
// src/components/yj/targetSelected.vue